import { contactCreate } from "./contactApi";

export const contactCreateAction = async ({ request }) => {
  const formData = await request.formData();

  const submission = {
    useSessionInfo: formData.get("useSessionInfo") === "true",
    request: formData.get("request"),
    status: formData.get("status"),
    firstName: formData.get("firstName"),
    lastName: formData.get("lastName"),
    email: formData.get("email"),
    phone: formData.get("phone"),
    longDescription: formData.get("longDescription"),
  };

  const res = await contactCreate(submission);

  return res;
};
